import { render, staticRenderFns } from "./SupporterViewUpdateDetails.vue?vue&type=template&id=24d49624&"
import script from "./SupporterViewUpdateDetails.vue?vue&type=script&lang=js&"
export * from "./SupporterViewUpdateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d49624')) {
      api.createRecord('24d49624', component.options)
    } else {
      api.reload('24d49624', component.options)
    }
    module.hot.accept("./SupporterViewUpdateDetails.vue?vue&type=template&id=24d49624&", function () {
      api.rerender('24d49624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supporters/views/Donations/SupporterViewUpdateDetails.vue"
export default component.exports